import AuthApi from '@/store/api/system/auth';
import axios from 'axios';
import Echo from 'laravel-echo';

const AUTH_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_BROADCASTING_AUTH_ROUTE}`;

class echo {
    constructor() {
        this.client = undefined;
        // Counts the clients built so far. A store that subscribed on client N
        // and remembers only "subscribed" never subscribes on client N+1; it
        // remembers the generation instead and compares.
        this.generation = 0;
    }
    initialize() {
        if (window.Pusher === undefined) window.Pusher = require('pusher-js');

        // Entering or leaving an account swaps the one token, and this is
        // re-run for it. The previous client held a socket authenticated as
        // whoever we were before; dropping the reference left that socket
        // and every channel subscribed on it alive.
        if (this.client) {
            this.client.disconnect();
            this.client = undefined;
        }

        this.generation += 1;
        this.client = new Echo({
            broadcaster: 'pusher',
            key: process.env.VUE_APP_PUSHER_APP_KEY,
            wsHost: process.env.VUE_APP_PUSHER_HOST,
            wsPort: process.env.VUE_APP_PUSHER_PORT,
            wssPort: process.env.VUE_APP_PUSHER_ENCRYPTED_PORT,
            forceTLS: false,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],

            // Pusher authorizes every private channel again on every
            // connection, and a socket reconnects whenever the laptop wakes up
            // or the network blinks. A token handed over as a static header
            // is the token of the moment the client was built; the JWT lives
            // two hours, so the first reconnect after that was refused and
            // every private channel went silently dead until a reload. The
            // token is read when the authorization happens instead.
            authorizer: (channel) => ({
                authorize: (socketId, callback) => {
                    axios
                        .post(
                            AUTH_ENDPOINT,
                            { socket_id: socketId, channel_name: channel.name },
                            { headers: { Authorization: `Bearer ${AuthApi.getToken()}` } }
                        )
                        .then((response) => callback(null, response.data))
                        .catch((error) => callback(error, null));
                },
            }),
        });

        // Bound here, per client: App.vue used to bind this once at mount, so
        // the client built on entering or leaving an account had no reconnector.
        const connection = this.client.connector.pusher.connection;

        // Pusher gives up after its own retries; we do not.
        connection.bind('state_change', ({ current }) => {
            if (current === 'disconnected' || current === 'failed') connection.connect();
        });

        // A broadcast sent while the socket was down is not replayed. Whoever
        // filled a badge or a clock once and relies on the socket to keep it
        // moving has to ask again when the socket is back (Navigation.vue).
        connection.bind('connected', () => {
            document.dispatchEvent(new CustomEvent('echo:connected'));
        });
    }
}

export default new echo();
